const actions = {
  USER_ADD_NEW: "USER_ADD_NEW",
  USER_READ: "USER_READ",
  USER_READ_SUCCESS: "USER_READ_SUCCESS",
  USER_UPDATE: "USER_UPDATE",
  USER_FIND_BY_ID: "USER_FIND_BY_ID",
  USER_LIST_SUCCESS: "USER_LIST_SUCCESS",
  USER_ITEM_SUCCESS: "USER_ITEM_SUCCESS",

  userAddNew: (history, dataObj) => ({
    //Action creator function
    type: actions.USER_ADD_NEW, //Action
    payload: { history, dataObj }, //pass payload to action, we should pass as little data to action
  }),

  userRead: (readFilter, page) => ({
    //Action creator function
    type: actions.USER_READ, //Action
    payload: { readFilter, page }, //pass payload to action, we should pass as little data to action
  }),
  onPageChange: (readFilter, page) => ({
    type: actions.USER_READ,
    payload: { readFilter, page },
  }),
  userReadSearchSuccess: (data, success, total_count, page, info) => ({
    type: actions.USER_READ_SUCCESS,
    data,
    success,
    total_count,
    page,
    info
  }),
};
export default actions;
